<template>
    <div>
      <!--添加通知信息-->
      <div class="logindiv" id="AddForm_lunbo">
        <div class="loginForm">
          <div style="width: 100%;height: 40px;background-color: #2d2d2d;margin: 0 auto;">
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
              添加新展示
            </span>
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
              <a href="javascript:;" @click="close">
                <i class="el-icon-close"></i>
              </a>
            </span>
          </div>
          <div style="width: 300px;margin: 0 auto;">
            <el-form :model="AddForm" style="margin-top: 50px;">
              <el-form-item prop="title">
                <el-input type="text" v-model="AddForm.url" placeholder="需要跳转的页面"></el-input>
              </el-form-item>
              <el-form-item prop="img">
                <el-upload
                  class="avatar-uploader"
                  ref="upload_photo"
                  action="/api/AddLunbo"
                  :data="AddForm"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  :auto-upload="false"
                  :on-change="changephoto"
                  :on-remove="handleRemove"
                  :headers="myHeaders"
                  :limit="1"
                  list-type="picture">
                  <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传图片文件，且不超过3MB，最多上传1个文件</div>
                </el-upload>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="loading" style="width: 300px;" @click="AddLunbo">提交</el-button>
              </el-form-item>
            </el-form>
          </div>
          <br>
        </div>
      </div>
      <div>
        <el-container>
          <el-header style="background-color:white;margin-top: 5px;height: 40px;">
            <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini">
              <el-form-item>
                <el-button type="primary" class="btn" @click="Addwindow()"><i class="el-icon-circle-plus-outline"></i>添加新展示</el-button>
              </el-form-item>
              <el-form-item label="起始日期">
                <el-date-picker v-model="formInline.statetime" type="datetime" value-format="timestamp" placeholder="起始日期"></el-date-picker>
              </el-form-item>
              <el-form-item label="结束日期">
                <el-date-picker v-model="formInline.endtime" type="datetime" value-format="timestamp" placeholder="结束日期"></el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="btn" @click="getData()"><i class="el-icon-search"></i>查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="danger" class="btn" @click="resetting()"><i class="el-icon-refresh"></i>重置</el-button>
              </el-form-item>
            </el-form>
          </el-header>
          <el-main class="elMain">
            <el-table v-loading="loading" :data="tableData" height="100%" stripe border size="medium ">
              <el-table-column align="center" label="ID" prop="id" width="100"></el-table-column>
              <el-table-column align="center" label="跳转地址" prop="url" width="250"></el-table-column>
              <el-table-column align="center" label="图片内容" prop="img">
                <template slot-scope="scope">
                  <img :src="scope.row.img" alt="" width="400px">
                </template>
              </el-table-column>
              <el-table-column align="center" label="发布时间" prop="time" width="200">
                <template slot-scope="scope">
                  <span>{{scope.row.time*1 | formatDate}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="是否展示" prop="type" width="100">
                <template slot-scope="scope">
                  <span style="color: green;" v-if="scope.row.type=='1'">展示</span>
                  <span style="color: red;" v-else>不展示</span>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="150">
                <template slot-scope="scope">
                  <span v-if="scope.row.type=='0'">
                    <el-button size="small" @click="updateLunboType(scope.row)">展示</el-button>
                  </span>
                  <span v-else>
                    <el-button size="small" @click="updateLunboType(scope.row)">不展示</el-button>
                  </span>
                  <span>
                    <el-popconfirm
                      confirmButtonText='好的'
                      cancelButtonText='不用了'
                      icon="el-icon-info"
                      iconColor="red"
                      title="这是一段内容确定删除吗？"
                      @onConfirm="deletes(scope.$index, scope.row)"
                    >
                      <el-button size="small" slot="reference">删除</el-button>
                    </el-popconfirm>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <el-footer>
            <div style="padding: 15px 0;text-align: right;">
              <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formInline.pageNum"
                :page-sizes="pageSizes" :page-size="formInline.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
              </el-pagination>
            </div>
          </el-footer>
        </el-container>
      </div>

      <div class="Orderinfordiv" id="updateIMage1">
        <imageCJ ref="child_IMAGE" @fatherMethod="fatherMethod" width="1000" height="350" :img_date="img_date" div_name="updateIMage1"></imageCJ>
      </div>

    </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
  import imageCJ from '@/img_update/images_UP.vue'//头像裁剪
  let Atoken=sessionStorage.getItem("Atoken")
  export default {
    components: {
      'imageCJ': imageCJ,
    },
    data() {
      return {
        myHeaders: {
          Atoken:Atoken,
        },
        data:'',
        imageUrl:'',
        tableData: [],
        loading: false,
        formInline: {
          statetime:'',
          title:'',
          endtime:'',
          //type:'0',
          pageNum:1,
          pageSize:10
        },
        pageSizes:[5, 10, 15, 20],
        pageTotal:0,
        AddForm:{
          admin_id:'',
          url:'',
        },
        //用来修改数据
        update:{
          id:'',
        },

        //
        img_date:null,
        newfile:null,
      }
    },

    filters: {
          formatDate: function (value) {
            /*返回总体日期*/
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? ('0' + MM) : MM;
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            let h = date.getHours();
            h = h < 10 ? ('0' + h) : h;
            let m = date.getMinutes();
            m = m < 10 ? ('0' + m) : m;
            let s = date.getSeconds();
            s = s < 10 ? ('0' + s) : s;
            //return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
            /*返回判断日期*/
            let timestamp = (new Date()).valueOf();
            let time=timestamp-value;//时间差
            let minute = 1000*60;
            let hour = minute * 60;
            var day = hour * 24;
            let times="";//内容
            let min = time/minute;//分钟
            let hours = time/hour;//天数
            return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
          }
        },

    created() {
      //this.getData();
    },
    //页面开启时执行
    mounted(){
      this.chark();
      this.getData();
    },
    methods: {
      //进行判定
      chark(){
        this.$emit("parentHandle", 2)
      },
      //修改展示状态
      updateLunboType(row){
        let admin_id=this.$store.state.a_id;
        this.update.id=row.id;
        this.update.admin_id=admin_id;
        this.update.type=row.type;
        //console.log(index, row);
        commonAPI('updateLunboType',this.update).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.getData();
          }
        }).catch(error=>{
          this.loading = false;
          this.$notify({//这里采用element ui的一个错误显示效果模板
            title: '提示',
            message: error.message,
            position: 'bottom-right',
            type: 'error'
          });
        })
      },
      //修改图片成功
      handleAvatarSuccess(res, file) {
        if(this.response.response(res)){
          this.getData();
          this.close();
        }
      },
      //删除当前文件
      handleRemove(file, fileList) {
        //console.log(file, fileList);
        this.imageUrl = '';
      },
      fatherMethod(data){
        this.newfile=data;
        this.$refs['upload_photo'].clearFiles();//清除文件
        this.$refs['upload_photo'].handleStart(data);//选择文件后的赋值方法
        //this.$refs.upload_photo.submit();
        //console.log("123"+data);
      },
      //改变图片框状态
      changephoto(file, fileList){
        this.imageUrl = URL.createObjectURL(file.raw);
        if(this.newfile!==null&&file.name==this.newfile.name){
          return false;
        }else{
          this.img_date=file;
          this.openInformation();
        }
        //console.log(file);
      },
      openInformation(){
        document.getElementById('updateIMage1').style.display='block';
        document.getElementById('zhedang').style.display='block';
      },
      beforeAvatarUpload(file) {
        let types = ['image/jpeg', 'image/gif', 'image/bmp', 'image/png'];
        const isImage = types.includes(file.type);
        const isLtSize = file.size / 1024 / 1024 < 3;
        if (!isImage) {
        this.$message.error('上传图片只能是 JPG、GIF、BMP、PNG 格式!');
        }
        if (!isLtSize) {
        this.$message.error('上传图片大小不能超过 5MB!');
        }
        return isImage && isLtSize;
      },
      //重置查询
      resetting() {
        this.formInline.statetime = '';
        this.formInline.endtime = '';
        this.getData();
      },
      //添加内容
      AddLunbo(){
        this.AddForm.admin_id=this.$store.state.a_id;
        if(this.AddForm.url==''||this.imageUrl==''){
          this.$notify({
          title: '提示',
          message: '请填写完整数据',
          position: 'bottom-right',
          type: 'error'
          });
          return false;
        }
        this.$refs.upload_photo.submit();
      },
      Addwindow(row){
        //this.AddForm.message_id=row.id;
        document.getElementById('AddForm_lunbo').style.display='block';
        document.getElementById('zhedang').style.display='block';
        //console.log('打开窗口');
      },
      //删除
      deletes(index, row) {
        let admin_id=this.$store.state.a_id;
        this.update.id=row.id;
        this.update.admin_id=admin_id;
        //console.log(index, row);
        commonAPI('deleteLunbo',this.update).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.getData();
          }
        }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
      },
      //查询
      getData() {
        this.loading = true,
        commonAPI('queryLunboLists',this.formInline).then(res => {
          this.loading = false;
          this.tableData = res.data.data.rows;
          this.pageTotal=res.data.data.total;
          //console.log(res.data.rows);
        })
      },
      onSubmit() {
        this.getData();
      },
      handleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.formInline.pageSize=val;
        this.formInline.pageNum=1;
        this.getData();
      },
      handleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.formInline.pageNum=val;
        this.getData();
      },
      close(){
        this.AddForm.title='';
        this.AddForm.content='';
        document.getElementById('AddForm_lunbo').style.display='none';
        document.getElementById('zhedang').style.display='none';
      },
    }
  }
</script>

<style scoped>
  .elInput,
  .btn {
    margin-top: 0px;
  }
  .el-main {
    padding: 5px 10px;
  }
  .elMain{
    height: 700px;
  }
  .el-table th {
    height: 45px;
    font-size: 16px;
    font-family: 微软雅黑;
    font-weight: 500;
    color: darkblue;
  }
  /**登录框架*/
  .logindiv{
    position: fixed;
    top: 25%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2002;
    overflow: auto;
    text-align: center;
    display: none;
  }
  .loginForm{
    margin: 0 auto;
    width: 550px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .loginForm a{
    color: #fff;
  }
  .loginForm a:hover{
    color: #d6d6d6;
  }

  /**Orderinfor框架*/
  .Orderinfordiv{
    position: fixed;
    top: 13%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2002;
    overflow: auto;
    display: none;
  }
  .OrderinforForm{
    margin: 0 auto;
    width: 900px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .OrderinforForm a{
    color: #fff;
  }
  .OrderinforForm a:hover{
    color: #d6d6d6;
  }
  .playlistbox_botton{
     width: 900px;margin: 0 auto;
     overflow: hidden;
     height: 633px;
     overflow-y: scroll;
   }
   /**滚动条样式*/
   .playlistbox_botton::-webkit-scrollbar{
     width: 5px;
   }
   .playlistbox_botton::-webkit-scrollbar-thumb{
     border-radius: 10px;
     -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
     background: #535353;
   }
   .playlistbox_botton::-webkit-scrollbar-thumb{
     -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
     border-radius: 10px;
     background: #EDEDED;
   }
   /**！Orderinfor框架*/
</style>



// WEBPACK FOOTER //
// src/admin/views/system/Lunbo.vue